<template>
    <div class="bjqdqa-box">
        <div class="content">
            <h3>1.数字人民币是什么？</h3>
            <p>数字人民币是由中国人民银行发行的数字形式的法定货币。由指定运营机构参与运营，以广义账户体系为基础，支持银行账户松耦合功能，与实物人民币等价，具有价值特征和法偿性、支持可控匿名。</p>
            <h3>2.为什么在便捷青岛APP里，我无法签约数字人民币支付？</h3>
            <p>出现这种情况可能有以下几种原因：</p>
            <p>（1）是您的便捷青岛APP未更新，请在应用市场下载最新版本的便捷青岛APP；</p>
            <p>（2）是便捷青岛APP更新后未重启，请彻底关闭便捷青岛APP的进程后重新登录；</p>
            <p>（3）是活动还尚未开始；</p>
            <p>（4）是您还未开通工行数字人民币个人钱包。由于便捷青岛APP与工行系统直连，未开通工行数字人民币个人钱包则无法选择此支付方式。</p>
            <h3>3、为什么我乘车时扣款不是1分钱？</h3>
            <p>乘客支付1分钱数字人民币乘车，仅限活动期间内且活动优惠金额尚有剩余的情况下有效，在活动开始前和活动优惠金额用完后均需支付正常票款。琴岛通二维码账户余额支付不享受此优惠。</p>
            <h3>4、为什么我签约并使用数字人民币免密支付3次之后，我的数字人民币乘车码被冻结了？</h3>
            <p>如用户有3次欠款未补齐，系统将自动冻结展码乘车功能。请您根据页面提示补齐费用后才能继续使用该功能。</p>
        </div>
    </div>
</template>

<script>
import { setStore } from '@/utils/index'

export default {
  name: 'icbcQA',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const accessToken = this.$route.query.accessToken
    if (accessToken) {
      setStore('token', accessToken)
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.bjqdqa-box {
    position: relative;
    min-height: 100vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.content {
    width: (680vw / 7.5);
    display: flex;
    flex-direction: column;
    color: #282728;
    font-size: 14px;
    line-height: 20px;

    p {
        font-weight: 400;
    }

    h3 {
        font-weight: 900;
        margin-top: 20px;
        margin-bottom: 5px;
    }
}

</style>
